import type { FaireProductEntity } from "../../entity_types/product";

export const p_42eubmgvzt: FaireProductEntity = {
  token: "p_42eubmgvzt",
  type: "product",
  name: "WISCONSIN Toddler Cotton Tee Graphics - State or Cheese Curd",
  brandToken: "b_8kumxdqk",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b83eeb4b26c0fe2b18f1e4a405765b795bc93edbc2d22abd552e9c5deb4aecc4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a68c56e19b764849dcc79ba49f72aa3552fe819e35034c791f443c527b9da865.png",
    "https://cdn.faire.com/fastly/de4678e6fadc1a4927131bfa2a420b6fccedb923d087a8d96843f7db3ab3d7f3.png",
    "https://cdn.faire.com/fastly/bb67a9055d2a1118a91ff21b2d7ef151191516d932e056575e28d9838ce144b1.png",
    "https://cdn.faire.com/fastly/64e585f7c0b224160d15b460cfe66509bb8b61c0a27e3d0d3aef07b6f276cdaf.png",
  ],
  priceDollars: 13.17,
  description:
    "Two Popular Wisconsin themed graphics for your tee shop!  We offer in multiple colors and sizes, and can always customize for your Midwest store!\n\n*Printed on Rabbit Skin Brand: 100% Combed Ringspun Cotton Fine Jersey\n\nFabrication: 4.5 oz. 100% combed ringspun cotton fine jersey • Heather is 90/10 combed ringspun cotton/polyester .  EasyTear™ label\n\nSafety: CPSIA compliant tracking label in side seam\n\nCare: Machine wash • Tumble dry low\n\nFit: Toddler Unisex\n\n*Items are silk screen printed with water based ink. \n\n *If you'd like other colored tees, please inquire and we can send you more options!\n",
  tags: [],
  msrpDollars: 26.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:21.590Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
